/**
 * Tipo de valor para filtros: apenas data (sem horário), com calendário nativo (input type=date).
 */
function pad2(n)
{
	return String(n).padStart(2, '0');
}

function toIsoDate(y, m, d)
{
	return `${y}-${pad2(m)}-${pad2(d)}`;
}

export default function filter_date()
{
	return {
		kind: 'date',
		regex: /^(?:(\d{4})-(\d{2})-(\d{2})(?:T[\d:.+-Z]*)?|(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4}))$/,
		store_mask(_m, y, mo, d, dd, mm, yyyy)
		{
			return toIsoDate(y ?? yyyy, mo ?? mm, d ?? dd);
		},
		display_mask(_m, y, mo, d, dd, mm, yyyy)
		{
			return toIsoDate(y ?? yyyy, mo ?? mm, d ?? dd);
		},
		captureEvents(_this = this)
		{
			this.safeProtoCall(_this);
			const node = _this.queryNode();
			if (node)
			{
				node.type = 'date';
				node.removeAttribute('placeholder');
				if (!node.getAttribute('title'))
					node.setAttribute('title', 'Selecione a data');
			}
		},
		refresh()
		{
			this.safeProtoCall();
			const node = this.queryNode();
			if (!node)
				return;
			node.type = 'date';
			const v = this.getValue();
			if (v == null || v === '')
			{
				node.value = '';
				return;
			}
			const s = String(v).trim();
			if (this.checkValue(s))
				node.value = this.format(s);
			else
			{
				const iso = s.match(/^(\d{4}-\d{2}-\d{2})/);
				node.value = iso ? iso[1] : '';
			}
		},
	};
}
